import { render, staticRenderFns } from "./detail-form.vue?vue&type=template&id=692d41d0&scoped=true&"
import script from "./detail-form.vue?vue&type=script&lang=js&"
export * from "./detail-form.vue?vue&type=script&lang=js&"
import style0 from "./detail-form.vue?vue&type=style&index=0&id=692d41d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "692d41d0",
  null
  
)

export default component.exports